import { apiSlice } from "../../app/api/apiSlice";
import { urlConfig } from "../../config";

export interface GiftBoxStatus {
  canOpen: boolean;
  nextEligibleAt?: string;
  goldenBoxesLeft: number;
  message?: string;
  /** When false, feature is disabled; hide Treasury Chest UI. */
  enabled?: boolean;
}

export interface GiftBoxOpenResponse {
  won: boolean;
  amount?: number;
  message: string;
}

const base = `${urlConfig.transactionsBaseUrl}/transactions/gift-box`;

export const treasurySlice = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    getGiftBoxStatus: build.query<GiftBoxStatus, void>({
      query: () => `${base}/status`,
      providesTags: ["TreasuryChest"],
    }),
    openGiftBox: build.mutation<GiftBoxOpenResponse, void>({
      query: () => ({
        url: `${base}/open`,
        method: "POST",
      }),
      invalidatesTags: ["TreasuryChest", "Wallet"],
    }),
  }),
});

export const { useGetGiftBoxStatusQuery, useOpenGiftBoxMutation } = treasurySlice;
